import { LanguageService } from './../services/LanguageHandler'
const _ = require('lodash')

export default {
  setLanguage (state, language) {
    state.uiLanguage = language
    LanguageService.setLanguage(language)
  },
  setCache (state, {name, value}) {
    Object.assign(state.cache, {[name]: value})
  },
  removeCache (state, name) {
    if (name) {
      state.cache = _.omit(state.cache, [name])
    }
    state.cache = {}
  },
  setUser (state, user) {
    state.user = user
    if (user.lang) {
      state.uiLanguage = user.lang
      LanguageService.setLanguage(user.lang)
    }
  },
  setUserHasCV (state, status) {
    state.userHasCV = status
  },
  setMetaInfo (state, meta) {
    state.metaInfo = meta
  },
  changeReRenderPageCounter (state) {
    state.reRenderPageCounter++
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js